import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/record.png';
const _withScopeId = n => (_pushScopeId("data-v-c75cecdc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card prompt-card"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prompt-card-left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "75px"
  }
})], -1));
const _hoisted_3 = {
  class: "prompt-card-center"
};
const _hoisted_4 = {
  class: "prompt-card-center-title"
};
const _hoisted_5 = {
  class: "prompt-card-center-content"
};
const _hoisted_6 = {
  key: 0,
  class: "prompt-card-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($props.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($props.content), 1)]), $props.btnText ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
    class: "fs-12 fw-medium text-black-600 cursor-pointe prompt-card-right-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.btnClick && $options.btnClick(...args))
  }, _toDisplayString($props.btnText), 1)])) : _createCommentVNode("", true)]);
}